import { Typography } from '@mui/material';
import { FC } from 'react';

const Terms: FC = () => {
  return (
    <>
      <Typography sx={styles.title}>
        Aviso de Privacidad y Autorización del Tratamiento de Datos de <br />
        Proveedores y/o clientes.
      </Typography>
      <br />
      <Typography sx={styles.text}>
        GASES DEL CARIBE S.A. ESP, empresa de servicios públicos domiciliarios,
        en calidad de responsable del tratamiento de datos personales,
        identificado con NIT 890101691-2 con domicilio principal en la ciudad de
        Barranquilla, comunica que los datos personales de identificación,
        ubicación y contacto, así como la demás información suministrada a
        través de este formulario será tratada para las siguientes finalidades:
        <b> (i) </b> Incluirlos en la base de datos de gestión de proveedores;
        <b> (ii) </b>
        Gestionar la ejecución de las actividades contratadas; <b> (iii) </b>
        Fortalecer el proceso del departamento de compras; <b> (iv)</b> Cumplir
        con las obligaciones legales exigibles a GASES DEL CARIBE S.A. ESP como
        puede ser el suministro de información a autoridades; <b> (v) </b>
        Gestionar los riesgos relacionados con la prevención del lavado de
        activos y financiación del terrorismo; <b> (vi) </b> Mantener canales
        adecuados de comunicación; <b> (vii) </b> Evaluar la ejecución de las
        actividades contratadas, incluidas las del personal del proveedor
        asignado a la ejecución de la actividad contratada; <b> (viii) </b>
        Comunicar información relacionada con las actividades de GASES DEL
        CARIBE S.A. ESP y/o de sus matrices, filiales, subordinadas y/o
        vinculadas, sea que estas se realicen de forma directa o en alianza con
        terceros, o que sean de interés para el sector de servicios públicos;
        <b> (ix) </b> Actualizar la información registrada ante GASES DEL CARIBE
        S.A. ESP, sea que esta se realice a través de bases de datos públicas
        y/o privadas con el fin de facilitar la comunicación; <b> (x) </b>{' '}
        Compartir la información de su condición de proveedor con la matriz,
        filiales, subordinadas y/o vinculadas;<b> (xi) </b> Involucrarlo en las
        actividades de responsabilidad social empresarial que realiza la
        empresa;<b> (xii) </b>
        Verificar la información suministrada como consecuencia del interés de
        ser proveedor por tener tal condición de proveedor de GASES DEL CARIBE
        S.A. ESP;<b> (xiii) </b> Tratar la información personal del proveedor y
        aquella originada en la gestión de la relación contractual con fines
        prospectivos, a través de procesos de analítica e Inteligencia de
        negocios;<b> (xiv) </b> Consultar, reportar y tratar la información del
        proveedor en centrales de crédito, bancos de datos o bases de datos
        públicas o privadas con el fin de identificar, analizar, evaluar e
        informar riesgos empresariales;<b> (xv) </b> Auditar el tratamiento que
        hace de los datos personales a los que acceda resultado de una relación
        contractual con GASES DEL CARIBE S.A. ESP;<b> (xvi) </b> Realizar los
        pagos originados en la relación contractual existente con GASES DEL
        CARIBE S.A. ESP y/o proponer negocios financieros para el pago, sea que
        esto se realice de forma directa y/o indirecta, caso en el cual GASES
        DEL CARIBE S.A. ESP será un mero gestor de la relación entre las partes
        intervinientes en la transacción financiera y <b> (xvii) </b> Tratar los
        datos personales en el marco de un interés legítimo vinculado a las
        finalidades directas y/o indirectas relacionadas con el objeto social de
        GASES DEL CARIBE S.A. ESP. El titular de los datos personales expresa
        que la información suministrada es veraz, exacta, fidedigna y legítima,
        así mismo entiende que tiene el deber de actualizar la información, sea
        por decisión propia, por solicitud de GASES DEL CARIBE S.A. ESP o de una
        autoridad. En este mismo sentido, afirma que, respecto de los datos
        personales que suministra o llegue a suministrar de sus empleados,
        subordinados, asesores o vinculados, ha obtenido previamente la
        autorización de estos; por tanto, se entiende que el tratamiento de los
        datos que realice GASES DEL CARIBE S.A. ESP respecto de esas personas se
        hace bajo el principio de buena fe y legalidad. La información personal
        recolectada y tratada será conservada de acuerdo con las reglas de
        temporalidad establecidas en la legislación comercial, contable,
        tributaria, tablas de retención documental adoptadas por GASES DEL
        CARIBE S.A. ESP y/o disposiciones especiales que sean aplicables a cada
        tipo de información. GASES DEL CARIBE S.A. ESP informa que los datos
        personales serán tratados conforme a las finalidades antes informadas y
        de su política de privacidad, la cual puede ser consultada en el
        siguiente enlace web www.gascaribe.com/privacy. Los datos personales en
        custodia de GASES DEL CARIBE S.A. ESP, en su condición de Responsable
        serán tratados cumpliendo los principios y regulaciones previstas en las
        leyes colombianas y las buenas prácticas aplicables al régimen de
        protección de datos personales. Se informa que los datos personales
        podrán ser tratados directamente y/o a través de terceros, en condición
        de encargados del tratamiento de datos, en centro de datos ubicados
        dentro o fuera de Colombia, en territorios como Estados Unidos, Europa,
        Latinoamérica, etc. <br /> <br />
      </Typography>

      <Typography sx={styles.text}>
        Para el ejercicio del Habeas Data, el titular del dato personal o quien
        demuestre un legítimo interés conforme lo señalado en la normatividad
        vigente y en nuestra política de protección de datos, podrá conocer,
        rectificar, modificar sus datos, o bien oponerse a un tratamiento, si
        ello es procedente, a través de los siguientes canales:
      </Typography>
      <ul style={styles.description}>
        <li>
          <Typography sx={styles.liText}>
            Correo electrónico:{' '}
            <a href="mailto:habeasdata@gascaribe.com">
              habeasdata@gascaribe.com
            </a>
          </Typography>
        </li>
        <li>
          <Typography sx={styles.liText}>Carrera 54 # 59 -144</Typography>
        </li>
        <li>
          <Typography sx={styles.liText}>
            En nuestros puntos de atención física.
          </Typography>
        </li>
        <li>
          <Typography sx={styles.liText}>
            Línea de atención telefónica (605) 3227000 desde teléfono fijo o
            celular.
          </Typography>
        </li>
        <li>
          <Typography sx={styles.liText}>
            Página web:{' '}
            <a
              href="https://gascaribe.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://gascaribe.com
            </a>
          </Typography>
        </li>
      </ul>
      <br />
      <Typography sx={styles.text}>
        Quien ejerza el habeas data deberá suministrar con precisión los datos
        de contacto solicitados para efecto de tramitar, atender y responder su
        solicitud y desplegar las cargas para el ejercicio de sus derechos.{' '}
        <br /> <br />
        Recibida la solicitud de ejercicio de Habeas Data,
        <b> GASES DEL CARIBE S.A. ESP </b> dará respuesta en los términos de ley
        y en nuestra política de protección de datos.
      </Typography>
    </>
  );
};

const styles = {
  title: {
    justifySelf: 'center',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '20px',
    color: '#000000',
  },
  text: {
    justifySelf: 'center',
    textAlign: 'justify',
    fontSize: '18px',
    color: '#000000',
  },
  liText: {
    justifySelf: 'left',
    textAlign: 'justify',
    fontSize: '18px',
    fontStyle: 'oblique',
    color: '#000000',
  },
  description: {
    fontSize: '18px',
    lineHeight: 3.5,
  },
};

export default Terms;
